import axios from 'axios'
import { signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { httpsCallable } from 'firebase/functions'
import { auth, functions } from '../../../services/firebase'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`

// Server should return AuthModel
export async function login(email: string, password: string) {
  const loginResponse = await signInWithEmailAndPassword(auth, email, password)
  const tokenResult = await loginResponse.user.getIdTokenResult()
  if(!tokenResult?.claims?.admin) {
    await signOut(auth)
    return null
  }
  return loginResponse.user
  // return axios.post<AuthModel>(LOGIN_URL, {
  //   email,
  //   password,
  // })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Reuse the client reset page through the assuranceski channel's email link.
export async function requestPassword(email: string): Promise<void> {
  const requestReset = httpsCallable<
    {email: string; channelCode: string},
    {error?: unknown}
  >(functions, 'request_password_reset')
  const {data} = await requestReset({email: email.trim(), channelCode: 'assuranceski'})
  if (data?.error) {
    throw new Error('Password reset request failed')
  }
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
